import { SecondaryNavGroup, SecondaryNavItem } from 'common/SecondaryNavigation/SecondaryNavigation.types';

export function isSecondaryNavGroup(item: SecondaryNavItem | SecondaryNavGroup | undefined): item is SecondaryNavGroup {
  if (!item) {
    return false;
  }
  return (item as SecondaryNavGroup).items !== undefined;
}
